<script>	
	import { appProfileState } from "../../state/ApplicationState.svelte";      
    import PersonalInfoHeader from "./PersonalInfoHeader.svelte";
    import PersonalInfoCard from "./PersonalInfoCard.svelte";
    import PersonalInfoEditor from "./PersonalInfoEditor.svelte";	              

    function startUpdate(event) {
		event.preventDefault();
        appProfileState.isEditorMode = true;		
        window.scrollTo(0, 0);
	}   

</script>

<main>
    <h1 class="mt-3 mb-3 ms-3 me-0">Personal Information</h1>
    <PersonalInfoHeader
        fullName = {appProfileState.memberDetails?.fullName}
        memberId = {appProfileState.memberDetails?.memberId}
        ssn = {appProfileState.memberDetails?.ssn}
        dateOfBirth = {appProfileState.memberDetails?.dateOfBirth}
    />

    {#if appProfileState.isEditorMode}   
        <PersonalInfoEditor />
    {:else}
        <PersonalInfoCard
            residentialAddress1 = {appProfileState.memberDetails?.residentialAddress1}
            residentialAddress2 = {appProfileState.memberDetails?.residentialAddress2}
            residentialCity = {appProfileState.memberDetails?.residentialCity}
            residentialState = {appProfileState.memberDetails?.residentialState}
            residentialZip = {appProfileState.memberDetails?.residentialZip}
            mailingAddress1 = {appProfileState.memberDetails?.mailingAddress1}
            mailingAddress2 = {appProfileState.memberDetails?.mailingAddress2}
            mailingCity = {appProfileState.memberDetails?.mailingCity}
            mailingState = {appProfileState.memberDetails?.mailingState}
            mailingZip = {appProfileState.memberDetails?.mailingZip}
            email = {appProfileState.memberDetails?.email}
            homePhone = {appProfileState.memberDetails?.homePhone}
            cellPhone = {appProfileState.memberDetails?.cellPhone}
            contactMethod = {appProfileState.memberDetails?.contactMethod}
            documentDeliveryMethod = {appProfileState.memberDetails?.documentDeliveryMethod}
            isPHIRestricted = {appProfileState.memberDetails?.isPHIRestricted}
            isUserSubscriber = {appProfileState.isUserSubscriber}
        />       
        {#if appProfileState.memberDetails?.hasPendingChanges}
            <div class="alert alert-warning">
                There are pending changes to your profile.
            </div>
        {:else}
            <div class="mt-3 mb-3">
	            <button class="btn btn-primary btn-lg" onclick={startUpdate}>Edit</button>
		    </div>  
        {/if}            
    {/if}   
</main>


